import BaseTemplate from '../src/layouts/BaseTemplate'
import AboutPage from '../src/view/_public/AboutView';

export default function About() {
  return (
    <BaseTemplate title="About" body={<AboutPage />} />
  )
}
